var _style, _rect, _g, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenSOrkan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000160908561622324958520000001533126662796317600_);}\r\n\t.st3{fill:url(#SVGID_00000062898890309910680520000010650807616153078941_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.3,91.5c0-2.5,0.8-4.5,2.4-6.1s3.8-2.4,6.4-2.4s4.7,0.8,6.3,2.4c1.6,1.6,2.4,3.6,2.4,6.1S24,96,22.4,97.6 s-3.7,2.3-6.3,2.3s-4.7-0.8-6.4-2.3C8.1,96.1,7.3,94,7.3,91.5z M16,96.1c2.5,0,4.3-1.9,4.3-4.5c0-2.7-1.7-4.5-4.3-4.5 s-4.3,1.8-4.3,4.5C11.8,94.1,13.5,96.1,16,96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,83.4c0.2,0,0.4,0.2,0.4,0.5V87c0,0.3-0.1,0.4-0.5,0.4c-0.2,0-0.6-0.1-1.1-0.1c-2.1,0-3.6,0.8-4.4,2.5v9.3 c0,0.3-0.1,0.4-0.4,0.4h-3.6c-0.3,0-0.4-0.1-0.4-0.4v-15c0-0.3,0.1-0.4,0.4-0.4H31c0.3,0,0.4,0.1,0.4,0.4v1.4 c1-1.4,2.5-2.1,4.5-2.1C36.2,83.3,36.6,83.3,37,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,83.6c0.4,0,0.5,0.3,0.2,0.5l-6,5.8l6.2,9.1c0.2,0.3,0,0.5-0.3,0.5h-4.2c-0.2,0-0.4-0.1-0.5-0.3L46.6,93l-2.8,2.7 v3.4c0,0.3-0.1,0.4-0.4,0.4h-3.6c-0.3,0-0.4-0.1-0.4-0.4V77.2c0-0.3,0.1-0.4,0.4-0.4h3.6c0.3,0,0.4,0.1,0.4,0.4v13.1l6.7-6.4 c0.1-0.1,0.3-0.2,0.5-0.2L55.5,83.6L55.5,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,84.1c0-0.3,0.1-0.4,0.4-0.4h3.6c0.3,0,0.4,0.1,0.4,0.4v15.1c0,0.3-0.1,0.4-0.4,0.4h-3.6c-0.3,0-0.4-0.1-0.4-0.4 v-1c-1.2,1.2-2.8,1.9-5,1.9c-2.4,0-4.3-0.8-5.8-2.3c-1.5-1.6-2.2-3.6-2.2-6.1c0-2.6,0.7-4.6,2.2-6.1c1.5-1.6,3.4-2.3,5.8-2.3 c2.2,0,3.8,0.6,5,1.8V84.1z M69.5,93.9v-4.7c-0.7-1.3-2.2-2.2-4-2.2c-2.7,0-4.4,1.8-4.4,4.5s1.7,4.5,4.4,4.5 C67.2,96,68.8,95.2,69.5,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7,89.9v9.2c0,0.3-0.1,0.4-0.4,0.4h-3.5c-0.3,0-0.4-0.1-0.4-0.4v-8.5c0-2.3-1.1-3.5-3.4-3.5c-1.6,0-2.7,0.6-3.5,1.8 v10.2c0,0.3-0.1,0.4-0.4,0.4h-3.6c-0.3,0-0.4-0.1-0.4-0.4v-15c0-0.3,0.1-0.4,0.4-0.4h3.6c0.3,0,0.4,0.1,0.4,0.4v0.7 c1.2-1.1,2.8-1.7,4.7-1.7C90.2,83.1,92.7,85.6,92.7,89.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50,
    y1: 100.3945,
    x2: 50,
    y2: 34.8939,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E17F14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#E07C14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#DF7414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#DC6515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#D95116"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    style: {
      stopColor: "#D53718"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    style: {
      stopColor: "#D0171A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CF101B"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    className: "st1",
    width: 70.6,
    height: 18.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181768529977292456830000015789431482391794062_",
    gradientUnits: "userSpaceOnUse",
    x1: 50,
    y1: 100.3945,
    x2: 50,
    y2: 34.8939,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E17F14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#E07C14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#DF7414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#DC6515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#D95116"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    style: {
      stopColor: "#D53718"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    style: {
      stopColor: "#D0171A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CF101B"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 26,
    style: {
      fill: "url(#SVGID_00000181768529977292456830000015789431482391794062_)"
    },
    width: 70.6,
    height: 18.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072995870680864941710000014977482257509584808_",
    gradientUnits: "userSpaceOnUse",
    x1: 50,
    y1: 100.3945,
    x2: 50,
    y2: 34.8939,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E17F14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#E07C14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#DF7414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#DC6515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#D95116"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    style: {
      stopColor: "#D53718"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    style: {
      stopColor: "#D0171A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CF101B"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 52,
    style: {
      fill: "url(#SVGID_00000072995870680864941710000014977482257509584808_)"
    },
    width: 70.6,
    height: 18.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenSOrkan);
export default __webpack_public_path__ + "static/media/token_sORKAN.174e4d90.svg";
export { ForwardRef as ReactComponent };